export const getDuration = (duration, conversation_created_at, messages, updated_at) => {
    if (messages.length == 0 || conversation_created_at == null) return "0s";
    
    const firstMsg = parseUTC(conversation_created_at);
    const updatedAtDate = parseUTC(updated_at);

    var diffMs = updatedAtDate - firstMsg;
    if (diffMs > 3600000) {
        diffMs = diffMs - 3600000
    }
    var totalSeconds = Math.floor(diffMs / 1000);

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    let val = minutes ? `${minutes}min` : '';
    return val += seconds + "s";

}

export const getMessagesDuration = (conversation_created_at, messages, updated_at) => {

    if (messages.length == 0 || conversation_created_at == null) return "0s";



    let firstMsg = parseUTC(conversation_created_at);

    let lastMsg = parseUTC(
        messages[messages.length - 1].created_at.split('.')[0]
    );

    let updatedAtDate = parseUTC(updated_at);

    if (updatedAtDate - lastMsg <= 45000 && updatedAtDate >= lastMsg) {
        lastMsg = updatedAtDate;
    }

    var diffMs = lastMsg - firstMsg;

    var totalSeconds = Math.floor(diffMs / 1000);

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    let val = minutes ? `${minutes}min` : '';
    return val += seconds + "s";
}
export default getDuration


const parseUTC = (dateStr) => {
    if (!dateStr) return null;
    let formatted = dateStr.replace(" ", "T");
    if (!formatted.endsWith("Z")) {
        formatted += "Z";
    }

    return new Date(formatted);
};